import { LicenseManager } from "ag-grid-enterprise";
import React, { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Routes, useLocation, Route } from "react-router";
import { useStore } from "../store";
import { useAppSettings } from "../utils/app-settings";
import { useInsights } from "../utils/insights";
import { getPersistedUnauthorizedUrl } from "../utils/local-storage/authorization";
import Application from "./application";
import LoggedIn from "./auth/logged";
import Login from "./auth/login";
import { useMsalFlow } from "./auth/msal-flow";

LicenseManager.setLicenseKey(import.meta.env.VITE_REACT_APP_AG_GRID_LICENSE || "");

const Root = () => {
  const [state] = useStore();
  const { readAppSettings } = useAppSettings();
  const { setupInsights } = useInsights();
  const [settingsRead, setSettingsRead] = useState(false);
  const location = useLocation();

  const { useAddMsalEventCallback, useAutoRedirectToLoginWhenNoUser } = useMsalFlow();
  useAddMsalEventCallback();

  useEffect(() => {
    readAppSettings();
  }, []);

  useEffect(() => {
    setupInsights();
    setSettingsRead(state.settings ? true : false);
  }, [state.settings]);

  useAutoRedirectToLoginWhenNoUser();

  /**
   * The DefaultRouteComponent makes sure the catch-all route (*) always renders something
   * as React Router v.6 will render a default Outlet component if the element property
   * is empty.
   */
  const DefaultRouteComponent = useCallback(() => {
    if (state.user) return <Application user={state.user} />;
    else return <></>;
  }, [state.user]);

  // We must ensure settings are read before rendering the app, the api url is read from settings
  if (!settingsRead) {
    return <div></div>;
  }
  if (
    isMobile &&
    state.settings &&
    state.settings.MobileRedirectUrl &&
    state.settings.MobileRedirectUrl.length > 0
  ) {
    const mobileUrl = state.settings.MobileRedirectUrl.replace(/^(.+?)\/*?$/, "$1");
    const url = (getPersistedUnauthorizedUrl() || location.pathname).replace(/^(.+?)\/*?$/, "$1");
    window.location.replace(`${mobileUrl}${url}`);
    return <div />;
  }

  return (
    <React.StrictMode>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logged" element={<LoggedIn />} />
        <Route path="/no-access" element={<Login noAccess />} />
        <Route path="*" element={<DefaultRouteComponent />} />
      </Routes>
    </React.StrictMode>
  );
};

export default Root;
